var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperFullWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 17,
    viewBox: "0 0 101 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1553 5.85886L23.8145 0H17.1797L25.3451 11.9758V16.9572H30.9583V11.9758L39.1629 0H32.528L28.1553 5.85886Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8477 0H39.9609V16.9572H45.5742V13.5188H52.0417C53.7894 13.5188 59.1482 12.782 59.1482 6.5049C59.1482 0.227808 53.4477 0 51.8477 0ZM51.6698 8.52489H45.5742V4.99214H51.5737C52.3621 4.99214 53.8962 5.05087 53.8962 6.69177C53.8962 8.33268 52.5311 8.52489 51.6698 8.52489Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4141 16.9575H79.1119V12.2537H66.0273V10.7284H78.2825V6.21326H66.0273V4.71295H79.1119V0.0126953H60.4141V16.9575Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.536 11.9526C99.1823 11.0628 100.645 9.36848 100.645 6.22904C100.645 0.215347 94.9501 0 93.3483 0H80.9062V16.9572H86.5195V12.944H91.6238L94.4998 16.927L100.999 16.9555L97.536 11.9526ZM92.818 7.99275H86.5195V4.9512H92.7272C93.4693 4.9512 94.9163 5.00281 94.9163 6.41592C94.9163 7.82902 93.6295 7.99275 92.818 7.99275Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64885 0.00878906H0V5.65764H5.64885V0.00878906Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64885 11.3086H0V16.9574H5.64885V11.3086Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 5.6582V11.3071H11.2973V16.9577H16.9461V11.3071V5.6582H11.2973H5.64844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperFullWhite);
export default __webpack_public_path__ + "static/media/hyper-full-white.c7b9253c79f30a2b7143640dff8ab3b0.svg";
export { ForwardRef as ReactComponent };